import { IBrowserCommonUiModuleOptions } from '@assess/browser/common-ui';
import { fileAttachmentMimeTypes } from '@assess/shared/file-constants';

import { environment } from '../../environments/environment';

export const browserCommonUiConfig: IBrowserCommonUiModuleOptions = {
  fileUploadConfig: {
    maxFileBytes: environment.api.maxFileBytes,
    allowedFileTypes: fileAttachmentMimeTypes,
  },
  withCredentialsConfig: {
    origins: [environment.api.rootUrl],
  },
};
